<!-- Ported from account-v1/.../people/feedback/feedback.html.
     ft-sheet-tabs omitted (account-v2 wrapper passed an empty tabs array →
     rendered nothing). ft-loading-animation / ft-infinite-scroll replaced
     by *ngIf-gated state + IntersectionObserver (#scrollSentinel), same as
     DirectoryComponent. ft-daterange-picker is the native Angular component
     reused directly (camelCase inputs/output). -->
<section class="ft-master-section ft-people-feedback-master">
    <section class="ft-section people-feedback-header">
        <div class="ft-container">
            <div class="ft-supertitle">
                <span class="ft-count">{{getTotalRatings() | number}}</span>
                guests gave their rating
                <!-- during month date - month date, year -->
                <!-- in the past X days -->
                <ft-daterange-picker (changed)="dateRangeChanged($event)" [inlineMode]="true" [datesVisible]="false" />
            </div>
            <div *ngIf="getTotal() > 0">
                <div class="ft-heading">&ldquo;How likely are you to recommend us to friends?&rdquo;</div>
                <ft-ratings-meter [ratings]="ratings" />
            </div>
        </div>
    </section>

    <section class="ft-section ft-panels-list-section">
        <div class="ft-container">
            <div class="ft-section-header">
                <div class="ft-row">
                    <div class="ft-col-left">
                        <div class="ft-label">
                            <span>{{getTotal() | number}} responses</span>
                        </div>
                    </div>
                    <div class="ft-col-right">
                        <div class="ft-dropdown sort-toggle" ftClickClass toggleClass="active">
                            <a class="ft-btn ft-btn-outline-dark ft-dropdown-toggle">
                                {{filter.name}} <i class="ft-icn-caret-down"></i>
                            </a>
                            <ul class="ft-dropdown-menu">
                                <li *ngFor="let f of filters"
                                    (click)="changeFilter(f)">
                                    <a [ngClass]="{'active': f.name == filter.name}">
                                        {{f.name}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ft-panels-list">
                <div class="placeholder-panel"
                     *ngIf="!feedbacks.length && !isProcessingRequest">
                    There are no responses to show.<br/>
                    Please choose a different date range and sort option.
                </div>
                <div class="ft-row">
                    <div class="ft-col-33 ft-panels-list-column" *ngFor="let guestFeedback of feedbacks">
                        <ft-guest-card type="feedback"
                                        [guest]="guestFeedback"
                                        (selected)="details($event)" />
                    </div>
                </div>
                <div #scrollSentinel></div>
            </div>
        </div>
    </section>
</section>
<!-- Child state people.feedback.details — now native DetailsComponent (M5b),
     so a plain Angular <ui-view> hosts it; see DirectoryComponent. -->
<ui-view />
